/** Ordered lowest → highest privilege for comparisons. */
export const ROLE_ORDER = ['viewer', 'editor', 'admin'] as const;

export type UserRole = (typeof ROLE_ORDER)[number];

const ROLE_SET = new Set<string>(ROLE_ORDER);

export function parseRole(value: unknown): UserRole | null {
    if (typeof value !== 'string') return null;
    const n = value.trim().toLowerCase();
    return ROLE_SET.has(n) ? (n as UserRole) : null;
}

export function hasMinimumRole(userRole: UserRole | null, minimum: UserRole): boolean {
    if (!userRole) return false;
    const ui = ROLE_ORDER.indexOf(userRole);
    const mi = ROLE_ORDER.indexOf(minimum);
    return ui >= mi;
}
